import Modal from 'bootstrap/js/dist/modal';

document.addEventListener('DOMContentLoaded', function(){
    // show modal on load when query parameter is present

    const searchParams = new URLSearchParams(window.location.search);

    if ( searchParams.get('showAppModal') == null ) return; 

    const modalElem = document.getElementById('downloadAppModal');

    if (!modalElem) return;

    const modal = Modal.getOrCreateInstance(modalElem);

    modal?.show();
});